module.exports = __webpack_public_path__ + "static/media/Dashboard_06-Satchels.ca3ee686.jpg";